import gql from "graphql-tag";

export const SEND_RESET_PASSWORD_INSTRUCTIONS_EMAIL = gql`
  mutation SendResetPasswordInstructionsEmail($email: String!) {
    sendResetPasswordInstructionsEmail(email: $email) {
      success
    }
  }
`;

export const REQUEST_PHONE_VERIFICATION_CODE = gql`
  mutation requestPhoneVerificationCode(
    $countryCode: String!
    $phoneNumber: String!
  ) {
    requestPhoneVerificationCode(
      countryCode: $countryCode
      phoneNumber: $phoneNumber
    ) {
      response {
        success
        error
        trackingInfo
      }
    }
  }
`;

export const CONFIRM_PHONE_VERIFICATION_CODE = gql`
  mutation confirmPhoneVerificationCode(
    $countryCode: String!
    $phoneNumber: String!
    $verificationCode: String!
  ) {
    confirmPhoneVerificationCode(
      countryCode: $countryCode
      phoneNumber: $phoneNumber
      verificationCode: $verificationCode
    ) {
      response {
        success
        error
        trackingInfo
      }
    }
  }
`;

export const UPDATE_ACCOUNT_SETTINGS = gql`
  mutation UpdateAccount($accountSettingsInput: AccountSettingsInput!) {
    updateAccountSettings(accountSettingsInput: $accountSettingsInput) {
      account {
        id
        marketingOptIn
      }
    }
  }
`;
